__webpack_require__.p = "/REST-Countries-API-with-color-theme-switcher/";